export default "__VITE_PUBLIC_ASSET__ab329133__"